import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@pkp-g/core';

export const blacklistRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () => import('./pages').then(p => p.BlacklistListPage),
    title: 'UIMS - Blacklist',
  },
  {
    path: 'create',
    loadComponent: () => import('./pages').then(p => p.BlacklistCreateComponent),
    title: 'UIMS - Blacklist',
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./pages').then(p => p.BlacklistDetailsComponent),
    title: 'UIMS - Blacklist Details',
    canDeactivate: [CanDeactivateGuard],
  },
];
